import "phaser";
import GesturesPlugin from "phaser3-rex-plugins/plugins/gestures-plugin.js";

import { Game } from "./Game";
import { GameConstants } from "./GameConstants";
import { BootScene } from "./scenes/BootScene";
import { PreloadScene } from "./scenes/PreloadScene";
import { SplashScene } from "./scenes/splash-scene/SplashScene";
import { MazeScene } from "./scenes/maze-scene/MazeScene";

let game: Game;

window.onload = () => {
   
    const gameConfig = {

        version: GameConstants.VERSION,
        type:  Phaser.CANVAS,
        backgroundColor: "#000080",
        width: GameConstants.GAME_WIDTH,
        height: GameConstants.GAME_HEIGHT,

        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            parent: "content",
            width: GameConstants.GAME_WIDTH,
            height: GameConstants.GAME_HEIGHT
        },
        plugins: {
            scene: [{
                key: "rexGestures",
                plugin: GesturesPlugin,
                mapping: "rexGestures"
            },
            ]
        },
        scene:  [
                    BootScene, 
                    PreloadScene, 
                    SplashScene,
                    MazeScene
                ]
    };

    // If compilation error here, compare Phaser definitions file of working copy (phaser.d.ts, line 48040 on 27-05-2019)
    // Also make sure to delete all *.ts files in node_modules/trailz folder
    game = new Game(gameConfig);

    window.focus();
    resize();
    window.addEventListener("resize", resize, false);
};

function resize(): void {

    const canvas = document.querySelector("canvas");
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const windowRatio = windowWidth / windowHeight;

    const gameWidth: any = game.config.width;
    const gameHeight: any = game.config.height;

    const gameRatio = gameWidth / gameHeight;
    
    if (windowRatio < gameRatio) {
        canvas.style.width = windowWidth + "px";
        canvas.style.height = (windowWidth / gameRatio) + "px";
    } else {
        canvas.style.width = (windowHeight * gameRatio) + "px";
        canvas.style.height = windowHeight + "px";
    }
}
